import { createContext } from 'react';
import type { CoOwnersManagementType } from './types';

const CoOwnersManagement = createContext<CoOwnersManagementType>(
  {} as CoOwnersManagementType,
);

export default CoOwnersManagement;
